// @flow

import { useMemo } from 'react';
import { useQuery } from 'react-query';

import ComplianceApprovalService from '../../services/complianceApprovalService';

// The funnel's structure: which stages exist, their order, their grouping, the
// bar-versus-row flag, and the default selected stage. This is a global lookup
// (not property-scoped), so the query key carries no property and the data is
// shared across every property the user views.
//
// useErrorBoundary is deliberately false: a failure here should surface as the
// screen's own inline error state (via AsyncBox), not blank the page through an
// error boundary.
const useComplianceApprovalStagesQuery = (options?: Object) => {
  const complianceApprovalService = useMemo(
    () => new ComplianceApprovalService(),
    [],
  );

  return useQuery(
    ['compliance-approval-stages'],
    () => complianceApprovalService.getStages(),
    {
      refetchOnWindowFocus: false,
      useErrorBoundary: false,
      ...options,
    },
  );
};

export default useComplianceApprovalStagesQuery;
